/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ContactSalesRequest,
  ContactSalesRequestChoiceInput,
  ContactSalesRequestCompanyInput,
  ContactSalesRequestContactInput,
  ContactSalesRequestWorkshopItemsInput,
  CreateContactSalesRequestInput,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create contact sales request
 */
export const createContactSalesRequest = (
    createContactSalesRequestInput?: MaybeRefOrGetter<CreateContactSalesRequestInput>,
 signal?: AbortSignal
) => {
      createContactSalesRequestInput = toValue(createContactSalesRequestInput);

      return axiosClient<ContactSalesRequest>(
      {url: `/contact_sales_requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createContactSalesRequestInput, signal
    },
      );
    }




export const getCreateContactSalesRequestMutationKey = () => ['createContactSalesRequest'] as const;

export const getCreateContactSalesRequestMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactSalesRequest>>, TError,CreateContactSalesRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createContactSalesRequest>>, TError,CreateContactSalesRequestMutationVariables, TContext> => {

const mutationKey = getCreateContactSalesRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContactSalesRequest>>, CreateContactSalesRequestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createContactSalesRequest(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContactSalesRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createContactSalesRequest>>>
    export type CreateContactSalesRequestMutationBody = CreateContactSalesRequestInput | undefined
    export type CreateContactSalesRequestMutationError = ErrorType<SchemaValidationErrorResponse>
    export type CreateContactSalesRequestMutationVariables = {data?: CreateContactSalesRequestInput}

    /**
 * @summary Create contact sales request
 */
export const useCreateContactSalesRequest = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactSalesRequest>>, TError,CreateContactSalesRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createContactSalesRequest>>,
        TError,
        CreateContactSalesRequestMutationVariables,
        TContext
      > => {
      return useMutation(getCreateContactSalesRequestMutationOptions(options), queryClient);
    }
    /**
 * @summary Get contact sales request
 */
export const getContactSalesRequest = (
    publicId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      publicId = toValue(publicId);

      return axiosClient<ContactSalesRequest>(
      {url: `/contact_sales_requests/${publicId}`, method: 'GET', signal
    },
      );
    }




export const getGetContactSalesRequestQueryKey = (publicId: MaybeRefOrGetter<string>,) => {
    return [
    'contact_sales_requests',publicId
    ] as const;
    }


export const getGetContactSalesRequestQueryOptions = <TData = Awaited<ReturnType<typeof getContactSalesRequest>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(publicId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactSalesRequest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetContactSalesRequestQueryKey(publicId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactSalesRequest>>> = ({ signal }) => getContactSalesRequest(publicId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(publicId) !== null && toValue(publicId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContactSalesRequest>>, TError, TData>
}

export type GetContactSalesRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getContactSalesRequest>>>
export type GetContactSalesRequestQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get contact sales request
 */

export function useGetContactSalesRequest<TData = Awaited<ReturnType<typeof getContactSalesRequest>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 publicId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactSalesRequest>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContactSalesRequestQueryOptions(publicId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update package choice step
 */
export const updateContactSalesRequestChoice = (
    publicId: MaybeRefOrGetter<string>,
    contactSalesRequestChoiceInput?: MaybeRefOrGetter<ContactSalesRequestChoiceInput>,
 signal?: AbortSignal
) => {
      publicId = toValue(publicId);
contactSalesRequestChoiceInput = toValue(contactSalesRequestChoiceInput);

      return axiosClient<ContactSalesRequest>(
      {url: `/contact_sales_requests/${publicId}/choice`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: contactSalesRequestChoiceInput, signal
    },
      );
    }




export const getUpdateContactSalesRequestChoiceMutationKey = () => ['updateContactSalesRequestChoice'] as const;

export const getUpdateContactSalesRequestChoiceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestChoice>>, TError,UpdateContactSalesRequestChoiceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestChoice>>, TError,UpdateContactSalesRequestChoiceMutationVariables, TContext> => {

const mutationKey = getUpdateContactSalesRequestChoiceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContactSalesRequestChoice>>, UpdateContactSalesRequestChoiceMutationVariables> = (props) => {
          const {publicId,data} = props ?? {};

          return  updateContactSalesRequestChoice(publicId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactSalesRequestChoiceMutationResult = NonNullable<Awaited<ReturnType<typeof updateContactSalesRequestChoice>>>
    export type UpdateContactSalesRequestChoiceMutationBody = ContactSalesRequestChoiceInput | undefined
    export type UpdateContactSalesRequestChoiceMutationError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>
    export type UpdateContactSalesRequestChoiceMutationVariables = {publicId: string;data?: ContactSalesRequestChoiceInput}

    /**
 * @summary Update package choice step
 */
export const useUpdateContactSalesRequestChoice = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestChoice>>, TError,UpdateContactSalesRequestChoiceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateContactSalesRequestChoice>>,
        TError,
        UpdateContactSalesRequestChoiceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateContactSalesRequestChoiceMutationOptions(options), queryClient);
    }
    /**
 * @summary Update company step
 */
export const updateContactSalesRequestCompany = (
    publicId: MaybeRefOrGetter<string>,
    contactSalesRequestCompanyInput?: MaybeRefOrGetter<ContactSalesRequestCompanyInput>,
 signal?: AbortSignal
) => {
      publicId = toValue(publicId);
contactSalesRequestCompanyInput = toValue(contactSalesRequestCompanyInput);

      return axiosClient<ContactSalesRequest>(
      {url: `/contact_sales_requests/${publicId}/company`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: contactSalesRequestCompanyInput, signal
    },
      );
    }




export const getUpdateContactSalesRequestCompanyMutationKey = () => ['updateContactSalesRequestCompany'] as const;

export const getUpdateContactSalesRequestCompanyMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestCompany>>, TError,UpdateContactSalesRequestCompanyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestCompany>>, TError,UpdateContactSalesRequestCompanyMutationVariables, TContext> => {

const mutationKey = getUpdateContactSalesRequestCompanyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContactSalesRequestCompany>>, UpdateContactSalesRequestCompanyMutationVariables> = (props) => {
          const {publicId,data} = props ?? {};

          return  updateContactSalesRequestCompany(publicId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactSalesRequestCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateContactSalesRequestCompany>>>
    export type UpdateContactSalesRequestCompanyMutationBody = ContactSalesRequestCompanyInput | undefined
    export type UpdateContactSalesRequestCompanyMutationError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>
    export type UpdateContactSalesRequestCompanyMutationVariables = {publicId: string;data?: ContactSalesRequestCompanyInput}

    /**
 * @summary Update company step
 */
export const useUpdateContactSalesRequestCompany = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestCompany>>, TError,UpdateContactSalesRequestCompanyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateContactSalesRequestCompany>>,
        TError,
        UpdateContactSalesRequestCompanyMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateContactSalesRequestCompanyMutationOptions(options), queryClient);
    }
    /**
 * @summary Update contact step
 */
export const updateContactSalesRequestContact = (
    publicId: MaybeRefOrGetter<string>,
    contactSalesRequestContactInput?: MaybeRefOrGetter<ContactSalesRequestContactInput>,
 signal?: AbortSignal
) => {
      publicId = toValue(publicId);
contactSalesRequestContactInput = toValue(contactSalesRequestContactInput);

      return axiosClient<ContactSalesRequest>(
      {url: `/contact_sales_requests/${publicId}/contact`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: contactSalesRequestContactInput, signal
    },
      );
    }




export const getUpdateContactSalesRequestContactMutationKey = () => ['updateContactSalesRequestContact'] as const;

export const getUpdateContactSalesRequestContactMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestContact>>, TError,UpdateContactSalesRequestContactMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestContact>>, TError,UpdateContactSalesRequestContactMutationVariables, TContext> => {

const mutationKey = getUpdateContactSalesRequestContactMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContactSalesRequestContact>>, UpdateContactSalesRequestContactMutationVariables> = (props) => {
          const {publicId,data} = props ?? {};

          return  updateContactSalesRequestContact(publicId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactSalesRequestContactMutationResult = NonNullable<Awaited<ReturnType<typeof updateContactSalesRequestContact>>>
    export type UpdateContactSalesRequestContactMutationBody = ContactSalesRequestContactInput | undefined
    export type UpdateContactSalesRequestContactMutationError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>
    export type UpdateContactSalesRequestContactMutationVariables = {publicId: string;data?: ContactSalesRequestContactInput}

    /**
 * @summary Update contact step
 */
export const useUpdateContactSalesRequestContact = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestContact>>, TError,UpdateContactSalesRequestContactMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateContactSalesRequestContact>>,
        TError,
        UpdateContactSalesRequestContactMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateContactSalesRequestContactMutationOptions(options), queryClient);
    }
    /**
 * @summary Update workshop items step and submit the request
 */
export const updateContactSalesRequestWorkshopItems = (
    publicId: MaybeRefOrGetter<string>,
    contactSalesRequestWorkshopItemsInput?: MaybeRefOrGetter<ContactSalesRequestWorkshopItemsInput>,
 signal?: AbortSignal
) => {
      publicId = toValue(publicId);
contactSalesRequestWorkshopItemsInput = toValue(contactSalesRequestWorkshopItemsInput);

      return axiosClient<ContactSalesRequest>(
      {url: `/contact_sales_requests/${publicId}/workshop_items`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: contactSalesRequestWorkshopItemsInput, signal
    },
      );
    }




export const getUpdateContactSalesRequestWorkshopItemsMutationKey = () => ['updateContactSalesRequestWorkshopItems'] as const;

export const getUpdateContactSalesRequestWorkshopItemsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestWorkshopItems>>, TError,UpdateContactSalesRequestWorkshopItemsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestWorkshopItems>>, TError,UpdateContactSalesRequestWorkshopItemsMutationVariables, TContext> => {

const mutationKey = getUpdateContactSalesRequestWorkshopItemsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContactSalesRequestWorkshopItems>>, UpdateContactSalesRequestWorkshopItemsMutationVariables> = (props) => {
          const {publicId,data} = props ?? {};

          return  updateContactSalesRequestWorkshopItems(publicId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactSalesRequestWorkshopItemsMutationResult = NonNullable<Awaited<ReturnType<typeof updateContactSalesRequestWorkshopItems>>>
    export type UpdateContactSalesRequestWorkshopItemsMutationBody = ContactSalesRequestWorkshopItemsInput | undefined
    export type UpdateContactSalesRequestWorkshopItemsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>
    export type UpdateContactSalesRequestWorkshopItemsMutationVariables = {publicId: string;data?: ContactSalesRequestWorkshopItemsInput}

    /**
 * @summary Update workshop items step and submit the request
 */
export const useUpdateContactSalesRequestWorkshopItems = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactSalesRequestWorkshopItems>>, TError,UpdateContactSalesRequestWorkshopItemsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateContactSalesRequestWorkshopItems>>,
        TError,
        UpdateContactSalesRequestWorkshopItemsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateContactSalesRequestWorkshopItemsMutationOptions(options), queryClient);
    }
